import { Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import { RequireAuth } from './components/RequireAuth';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { OrdersListPage } from './pages/OrdersListPage';
import { OrderDetailPage } from './pages/OrderDetailPage';
import { AnalyticsPage } from './pages/AnalyticsPage';
import { CreateOrderPage } from './pages/CreateOrderPage';
import { DelivererDashboardPage } from './pages/DelivererDashboardPage';
import { KycPage } from './pages/KycPage';
import { ObservabilityPage } from './pages/ObservabilityPage';
import { AdminKycReviewPage } from './pages/AdminKycReviewPage';
import { HomePage } from './pages/HomePage';
import { ProfilePage } from './pages/ProfilePage';
import { HistoryPage } from './pages/HistoryPage';

export const App = () => (
  <Routes>
    <Route element={<Layout />}>
      <Route index element={<HomePage />} />
      <Route path="login" element={<LoginPage />} />
      <Route path="register" element={<RegisterPage />} />
      <Route
        path="orders"
        element={
          <RequireAuth>
            <OrdersListPage />
          </RequireAuth>
        }
      />
      <Route
        path="orders/:id"
        element={
          <RequireAuth>
            <OrderDetailPage />
          </RequireAuth>
        }
      />
      <Route
        path="admin/analytics"
        element={
          <RequireAuth roles={['admin']}>
            <AnalyticsPage />
          </RequireAuth>
        }
      />
      <Route
        path="orders/new"
        element={
          <RequireAuth roles={['client', 'business', 'admin']}>
            <CreateOrderPage />
          </RequireAuth>
        }
      />
      <Route
        path="deliverer"
        element={
          <RequireAuth roles={['deliverer', 'admin']}>
            <DelivererDashboardPage />
          </RequireAuth>
        }
      />
      <Route
        path="profil"
        element={
          <RequireAuth>
            <ProfilePage />
          </RequireAuth>
        }
      />
      <Route
        path="historique"
        element={
          <RequireAuth>
            <HistoryPage />
          </RequireAuth>
        }
      />
      <Route
        path="kyc"
        element={
          <RequireAuth roles={['deliverer', 'business', 'client', 'admin']}>
            <KycPage />
          </RequireAuth>
        }
      />
      <Route
        path="admin/observability"
        element={
          <RequireAuth roles={['admin']}>
            <ObservabilityPage />
          </RequireAuth>
        }
      />
      <Route
        path="admin/kyc"
        element={
          <RequireAuth roles={['admin']}>
            <AdminKycReviewPage />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Route>
  </Routes>
);
